export const SOCKET_ON_OPEN = '@@SOCKET.ON_OPEN';
export const SOCKET_ON_CLOSE = '@@SOCKET.ON_CLOSE';
export const SOCKET_ON_ERROR = '@@SOCKET.ON_ERROR';
export const SOCKET_ON_PING_TIMEOUT = '@@SOCKET.ON_PING_TIMEOUT';
